import { useContext } from "preact/compat";
import { createPortal } from "react-dom";
import useLocalStorageState from "use-local-storage-state";

import CartIcon from "@/icons/cart-icon.svg";
import HeartIcon from "@/icons/heart-icon.svg";
import { useToggleSideCart } from "@/hooks/toggleSideCart";
import { GlobalContext } from "@/context/GlobalContext";

function NavActions() {
	const target = document.querySelector(".site-nav-actions-dutchie");
	const onToggleSideCart = useToggleSideCart();
	const { cartItemCount, setCartItemCount } = useContext(GlobalContext);
	const [dutchieRetailer, setDutchieRetailer] = useLocalStorageState("dutchie_retailer", null);
	const hasItems = cartItemCount > 0 ? "has-items" : "";

	const locationName = dutchieRetailer?.shopButtonText ? dutchieRetailer.shopButtonText : dutchieRetailer?.name;

	if (!target) {
		return null;
	}

	return createPortal(
		<>
			<a href="/shop" className="site-nav-desktop-cta btn-white">
				Shop {locationName}
			</a>
			
			{ header_search ? (
				<div className="site-nav-search site-nav-icon">
					<button className="btn-reset" type="button" data-a11y-dialog-show="modal-search">
						<span className="sr-only">search website</span>
						<svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="#F7F5E1" strokeWidth="1.5" strokeMiterlimit="10"><path d="M8.951 17.255a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM14.951 15.255l9.35 9.35"/></g></svg>
					</button>
				</div>
			) : null }
			
			<div className="site-nav-account site-nav-icon">
				<a title="Wishlist" aria-label="View Wishlist" className="btn-reset btn-wishlist" href="/wish-list">
					<span className="sr-only">Wish List</span>
					<HeartIcon />
				</a>
			</div>

			<div className="site-nav-cart site-nav-icon">
				<button onClick={onToggleSideCart} className={`btn-reset site-nav-cart-link drawer-toggle ${hasItems}`} aria-controls="sidecart" aria-label="View Cart" aria-expanded="false" data-drawer="sidecart">
					<span className="sr-only">View Cart</span>
					<CartIcon />
				</button>
			</div>
		</>,
		target
	);
}
export default NavActions;